// extracted by mini-css-extract-plugin
export var body = "_jm-0";
export var sectionHeader = "_jm-4";
export var shortcutColumns = "_jm-2";
export var shortcutList = "_jm-1";
export var shortcutSection = "_jm-3";